import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnterpriseDto } from '../../common/interfaces/enterprise-dto';
import { PaginatedSearchResponse } from '../../common/interfaces/paginated-search-response';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class GroupSearchService {
    private http = inject(HttpClient);
    private env = inject(envToken);


    private baseUrl = '';

    constructor() {
        this.baseUrl = this.env.apiUrl + '/api/v1/enterprise';
    }

    getGroups(searchTerm: string, page: number, itemsPerPage: number, sortBy: string, sortOrder: string):
        Observable<PaginatedSearchResponse<EnterpriseDto>> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams()
            .set('searchTerm', searchTerm)
            .set('page', page)
            .set('size', itemsPerPage)
            .set('sort', sortBy + ',' + sortOrder);

        return this.http.get<PaginatedSearchResponse<EnterpriseDto>>(`${this.baseUrl}/search`, { headers, params });
    }

    getAllGroupIds(searchTerm: string, totalItems: number, sortBy: string, sortOrder: string): Observable<number[]> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams()
            .set('searchTerm', searchTerm)
            .set('page', 0)
            .set('size', totalItems)
            .set('sort', sortBy + ',' + sortOrder);

        return this.http.get<PaginatedSearchResponse<EnterpriseDto>>(`${this.baseUrl}/search`, { headers, params }).pipe(
            map(response => response.content.map(item => item.id!))
        );
    }

}
